export const COMMERCIAL_EMAIL = "lea.sanquer@akanthas.com";
export const LOGISTICS_EMAIL = "operations@akanthas.com";
export const SUPPORT_EMAIL = "support@akanthas.com";

export const SUPPORT_PHONE_DISPLAY = "+33 (0)9 70 70 16 75";
export const SUPPORT_PHONE_TEL = "tel:+33970701675";
export const SUPPORT_PHONE_CLIPBOARD = "+33970701675";
